<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'RulesBar',
  props: {
    scenarios: {
      type: Array,
      default: function () {
        return []
      }
    },
    titleSize: {
      type: String,
      default: '18px'
    },
    height: {
      type: Number,
      default: 400
    },
    exporting: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let scenario of this.scenarios) {
        for (let rule of scenario.rules) {
          let oindex = series.findIndex((obj) => obj.name === rule.name)
          if (oindex < 0) {
            series.push({
              name: rule.name,
              y: 1
            })
          } else {
            series[oindex].y += 1
          }
        }
      }
      return series.sort((a, b) => b.y - a.y)
    },
    options: function () {
      const self = this
      return {
        chart: {
          type: 'bar',
          height: this.height
        },
        exporting: {
          enabled: this.exporting
        },
        title: {
          text: ''
        },
        xAxis: {
          type: 'category',
          labels: {
            enabled: false
          }
        },
        yAxis: {
          labels: {
            enabled: false
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter () {
                return `${this.y}`
              }
            }
          }
        },
        series: [
          {
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key} ${self.$t('compGraphicsRulesBar.used')} <b>${
              this.y
            }</b> ${self.$t('compGraphicsRulesBar.times')}`
          }
        }
      }
    }
  }
}
</script>
